export default "__VITE_ASSET__CFh0tAHP__"